import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { useToast } from "../../controller/ToastController";
import { LANG_KO, langState, langText } from "../../recoil/lang";
import {
  checkoutDetailType,
  checkoutPayCompleteModalVisible,
} from "../../recoil/socket";
import "../../styles/CustomModal.css";

const ExtensionCheckoutModal = (oProps: {
  checkoutDetail: (checkoutDetailType & { hour_extension: number }) | undefined;
}) => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [lang, setLang] = useRecoilState<number>(langState);
  const [checkoutTime, setCheckoutTime] = useState<string | undefined>();
  const [isVisible, setIsVisible] = useRecoilState<boolean>(
    checkoutPayCompleteModalVisible
  );

  const modalSuccess = () => {
    setIsVisible(false);
    navigate(`/master`);
    showToast("2000원 쿠폰이 발급되었어요");
  };

  useEffect(() => {
    if (
      oProps.checkoutDetail &&
      oProps.checkoutDetail.checkout_time &&
      oProps.checkoutDetail.hour_extension
    ) {
      const time = moment(oProps.checkoutDetail.checkout_time, "HH:mm:ss")
        .add(oProps.checkoutDetail.hour_extension * 60, "minutes")
        .format("HH:mm");
      setCheckoutTime(time);
    } else {
      setCheckoutTime(undefined);
    }
  }, [oProps.checkoutDetail]);

  return (
    <Modal
      open={isVisible}
      onClose={modalSuccess}
      center
      classNames={{
        modal: "extensionCheckoutModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm_color.svg`}
              alt="bell"
            />
            <h2>{langText.extensionCheckoutModal_title[lang]}</h2>
            {checkoutTime ? (
              <div className="timeWrap">
                <img
                  className="alarm"
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm.svg`}
                  alt="alarm"
                />
                <h1>{checkoutTime}</h1>
              </div>
            ) : (
              <div className="timeWrap">
                <img
                  className="alarm"
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm.svg`}
                  alt="alarm"
                />
                <h1>{oProps.checkoutDetail?.hour_extension}시간 추가</h1>
              </div>
            )}
            <h3>
              {`${langText.extensionCheckoutModal_content_one[lang]}\n${langText.extensionCheckoutModal_content_two[lang]}`}
            </h3>
          </div>
          <button className="cancelButton" onClick={modalSuccess}>
            {langText.guideModal_button_confirm[lang]}
          </button>
        </div>
        <div className="modalFooter">
          <div className="between">
            <div className="between column">
              <h3>{langText.extensionCheckoutModal_footer_one[lang]}</h3>
              <h1 className={`${lang === LANG_KO ? "" : "small"}`}>
                {langText.extensionCheckoutModal_footer_two[lang]}
              </h1>
              <h1 className={`large ${lang === LANG_KO ? "" : "small"}`}>
                {langText.extensionCheckoutModal_footer_three[lang]}
              </h1>
              <h5>{langText.extensionCheckoutModal_footer_badge[lang]}</h5>
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/img/CheckoutCoupon02.png`}
              alt="coupon"
            />
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ExtensionCheckoutModal;

const Style = styled.div`
  .modal {
    width: 100%;
    height: 100%;
    padding: 6% 10%;
    padding-bottom: 3%;
  }

  .modal_header {
    width: 100%;
    min-height: 200px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    gap: 18px;
    padding-bottom: 20px;

    h2 {
      color: #737373;
      font-weight: 600;
    }
    h3 {
      font-size: 20px;
      line-height: 34px;
      color: #000;
    }

    .timeWrap {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 14px 32px;
      background: #f7f7f7;
      border-radius: 50px;
      margin-bottom: 6px;
      h1 {
        line-height: 32px;
        font-weight: 600;
        color: #40977f;
      }
    }
  }

  .cancelButton {
    margin-top: 6px;
    width: 100%;
    padding: 18px 0;
    background: #ffffff;
    border-radius: 10px;
    color: #4dd2ae;
    border: 2px solid #4dd2ae;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
  }

  .modalFooter {
    height: 20vh;
    padding: 6% 10% 7% 10%;
    background: #4dd2ae;
    .between {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .between.column {
      height: 100%;
      flex-direction: column;
      align-items: flex-start;
    }

    h1 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 400;
      color: #fff;
      font-family: "Jalnan2TTF";
    }
    h1.small {
      font-size: 28px;
      line-height: 36px;
      letter-spacing: -0.2rem;
    }
    h1.large {
      font-size: 40px;
      line-height: 56px;
    }
    h1.large.small {
      font-size: 32px;
      line-height: 48px;
    }
    h3 {
      font-size: 20px;
      color: #fff;
      font-weight: 400;
      margin-bottom: 10px;
    }
    img {
      width: 38%;
    }
    h5 {
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: #ffffff;
      padding: 4px 20px;
      background: #7d75dd;
      border-radius: 50px;
    }
  }
`;
